import { Injectable } from '@angular/core';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { OddConstant } from '~/constant/odd.constant';
import { uiHelper } from '~/helpers/ui.helper';

@Injectable()
export class GetOddData {
    // todo initial sportType must be defined on constants.
    sportTypeEnum = 1;

    constructor(public _ts: TournamentsService, private _oddConstant: OddConstant, private _uiHelper: uiHelper) {
        this.sportTypeEnum = this._uiHelper.sportEnum;
        this._uiHelper.sportEnum_Listener.subscribe(x => (this.sportTypeEnum = x));
    }

    // todo subscriscbe method may required

    get(type, matchID, oddTypes, isSecond = false) {
        const dataArry = [];

        try {
            oddTypes.forEach(oddTypeItem => {
                const _oddTypeItem = oddTypeItem;

                // for live
                //console.log("0:",type, this.sportTypeEnum.toString(),this.sportTypeEnum.toString(), this._oddConstant.ODD_TYPE_DROPDOWN[_oddTypeItem].odd_type);

                let oddTypeRebuild = this._oddConstant.ODD_TYPE_ID[type][this.sportTypeEnum.toString()][
                    this._oddConstant.ODD_TYPE_DROPDOWN[_oddTypeItem].odd_type
                ];

                //console.log("1:",oddTypeRebuild);
                let specialRebuild = this._oddConstant.ODD_TYPE_DROPDOWN[_oddTypeItem].SpecialBetValue || '';
                // console.log("2:",specialRebuild);

                if (isSecond) {
                    const oddType = this._oddConstant.ODD_TYPE_DROPDOWN[_oddTypeItem].odd_type;
                    oddTypeRebuild = this._oddConstant.ODD_TYPE_ID[type][this.sportTypeEnum.toString()][
                        this._oddConstant.ODD_TYPE_EQUIVALENT_2ND_ROW[oddType]
                    ];
                    specialRebuild = this._oddConstant.ODD_TYPE_DROPDOWN[_oddTypeItem].SpecialBetValue || '';
                }

                // wildcard ise burada kontrol edilir. Yani OU, Handicap
                if (this._oddConstant.ODD_TYPE_DROPDOWN[_oddTypeItem].wildcard) {
                    dataArry.push(this.getWildcardItem(type, matchID, _oddTypeItem, isSecond));
                } else {
                    if (type === 'live') {
                        let __data = this._ts.liveOddsList[`${matchID}/${oddTypeRebuild}/${specialRebuild}`];
                        const listRebuildData = this._oddConstant.LIST_REBUILD[
                            this._oddConstant.ODD_TYPE_ID[type][this.sportTypeEnum.toString()][
                                this._oddConstant.ODD_TYPE_DROPDOWN[_oddTypeItem].odd_type
                            ]
                        ];

                        if (listRebuildData && __data) {
                            __data = listRebuildData.filterHandler(__data);
                        }

                        // sırası kaymış oddların sıraları doğrultmak için boş odd datası eklenir.
                        Object.keys(this._oddConstant.ODD_TYPE_SEQUENCE_ID[type]).forEach(sequenceID => {
                            if (sequenceID == oddTypeRebuild && __data) {
                                // Special handling for Double Chance (odd type 24)
                                if (sequenceID == '24' && __data && __data.length > 0) {
                                    // Create a mapping for each expected ParameterOddId
                                    const oddMapping = {};
                                    const sequenceIds = this._oddConstant.ODD_TYPE_SEQUENCE_ID[type][sequenceID];

                                    // Initialize with empty placeholders
                                    sequenceIds.forEach(id => {
                                        oddMapping[id] = {
                                            OddId: -1,
                                            Visibility: 'hidden',
                                            OddValue: '0',
                                            BetStatus: 'none',
                                        };
                                    });

                                    // Fill in with actual data where available
                                    __data.forEach(odd => {
                                        if (
                                            odd &&
                                            odd.ParameterOddId &&
                                            oddMapping.hasOwnProperty(odd.ParameterOddId)
                                        ) {
                                            oddMapping[odd.ParameterOddId] = odd;
                                        }
                                    });

                                    // Create the ordered array
                                    const orderedData = sequenceIds.map(id => oddMapping[id]);
                                    __data = orderedData;
                                }
                                // Regular handling for other odd types
                                else if (__data.length < 3) {
                                    let retData = [];
                                    let _index = 0;
                                    this._oddConstant.ODD_TYPE_SEQUENCE_ID[type][sequenceID].forEach(oddItem => {
                                        // console.log( __data[_index].ParameterOddId , oddItem);
                                        if (
                                            _index != 2 &&
                                            __data[_index] &&
                                            __data[_index].ParameterOddId &&
                                            __data[_index].ParameterOddId == oddItem
                                        ) {
                                            retData.push(__data[_index]);
                                            _index++;
                                        } else {
                                            retData.push({
                                                OddId: -1,
                                                Visibility: 'hidden',
                                                OddValue: '0',
                                                BetStatus: 'none',
                                            });
                                        }
                                    });

                                    // console.log('data final', oddTypeRebuild, retData);

                                    __data = retData;
                                }
                            }
                        });

                        // Array rebuild completed. Pushing return array.
                        dataArry.push(__data);
                    } else if (type === 'pre') {
                        // re-asign sport type for prematch
                        oddTypeRebuild = this._oddConstant.ODD_TYPE_ID[type][this.sportTypeEnum.toString()][
                            this._oddConstant.ODD_TYPE_DROPDOWN[_oddTypeItem].odd_type
                        ];

                        if (this._ts.terminalOddList != null) {
                            let __data = this._ts.terminalOddList[`${matchID}/${oddTypeRebuild}/${specialRebuild}`];
                            const listRebuildData = this._oddConstant.LIST_REBUILD[
                                this._oddConstant.ODD_TYPE_ID[type][this.sportTypeEnum.toString()][
                                    this._oddConstant.ODD_TYPE_DROPDOWN[_oddTypeItem].odd_type
                                ]
                            ];
                            if (listRebuildData && __data) {
                                __data = listRebuildData.filterHandler(__data);
                            }

                            // Array rebuild completed. Pushing return array.
                            dataArry.push(__data);
                        }
                    }
                }
            });

            return dataArry;
        } catch (e) {
            console.warn('Odd Data Error', e);
            return dataArry;
        }
    }

    getWildcardItem(type, matchID, __oddTypeItem, isSecond = false) {
        let allData = [];

        if (this._oddConstant.ODD_TYPE_DROPDOWN[__oddTypeItem].isDataContainSameObject) {
            const oddTypeRebuild = this._oddConstant.ODD_TYPE_ID[type][this.sportTypeEnum.toString()][
                this._oddConstant.ODD_TYPE_DROPDOWN[__oddTypeItem].odd_type
            ];
            if (type === 'live') {
                allData.push(this._ts.liveOddsList[`${matchID}/${oddTypeRebuild}/`]);
            } else if (type === 'pre') {
                if (this._ts.terminalOddList != null)
                    allData.push(
                        this._ts.terminalOddList[
                            `${matchID}/${
                                this._oddConstant.ODD_TYPE_ID[type][this.sportTypeEnum.toString()][
                                    this._oddConstant.ODD_TYPE_DROPDOWN[__oddTypeItem].key
                                ]
                            }/`
                        ],
                    );
            }

            // console.log(allData,this._ts.liveOddsList[`${matchID}/${oddTypeRebuild}/`],oddTypeRebuild,matchID);
            if (allData[0]) {
                return allData[0].slice(0, 2);
            } else {
                return [];
            }
        }
        const ODD_VARIETY: any[] = this._oddConstant.ODD_VARIETY[
            this._oddConstant.ODD_TYPE_DROPDOWN[__oddTypeItem].key
        ];

        let oddTypeRebuild = this._oddConstant.ODD_TYPE_ID[type][this.sportTypeEnum.toString()][
            this._oddConstant.ODD_TYPE_DROPDOWN[__oddTypeItem].odd_type
        ];

        if (isSecond) {
            const oddType = this._oddConstant.ODD_TYPE_DROPDOWN[__oddTypeItem].odd_type;
            oddTypeRebuild = this._oddConstant.ODD_TYPE_ID[type][this.sportTypeEnum.toString()][
                this._oddConstant.ODD_TYPE_EQUIVALENT_2ND_ROW[oddType]
            ];
        }

        ODD_VARIETY.forEach(x => {
            if (type === 'live') {
                allData.push(this._ts.liveOddsList[`${matchID}/${oddTypeRebuild}/${x}`]);
                // console.log("pp", allData, isSecond, `${matchID}/${oddTypeRebuild}/${x}`);
            } else if (type === 'pre') {
                // console.log(`${matchID}/${this._oddConstant.ODD_TYPE_ID[type][this.sportTypeEnum.toString()][this.sportTypeEnum.toString()][this._oddConstant.ODD_TYPE_DROPDOWN[__oddTypeItem].key]}/${x}`);

                if (
                    this._oddConstant.ODD_TYPE_DROPDOWN[__oddTypeItem].key === 'HANDICAP_basket' ||
                    this._oddConstant.ODD_TYPE_DROPDOWN[__oddTypeItem].key === 'HANDICAP_handball'
                ) {
                    if (this._ts.terminalOddList != null)
                        allData.push(
                            this._ts.terminalOddList[
                                `${matchID}/${
                                    this._oddConstant.ODD_TYPE_ID[type][this.sportTypeEnum.toString()][
                                        this._oddConstant.ODD_TYPE_DROPDOWN[__oddTypeItem].key
                                    ]
                                }/${x}`
                            ],
                        );

                    // console.log(allData);
                } else {
                    if (this._ts.terminalOddList != null)
                        allData.push(
                            this._ts.terminalOddList[
                                `${matchID}/${
                                    this._oddConstant.ODD_TYPE_ID[type][this.sportTypeEnum.toString()][
                                        this._oddConstant.ODD_TYPE_DROPDOWN[__oddTypeItem].key
                                    ]
                                }/${x}`
                            ],
                        );
                }
            }
        });

        /*
        For Over/Under, special selection and grouping
         */
        if (this._oddConstant.ODD_TYPE_DROPDOWN[__oddTypeItem].key === 'OU') {
            let group = {};

            allData.forEach(item => {
                if (item) {
                    item.forEach(item2 => {
                        if (!group[item2.SpecialBetValue]) {
                            group[item2.SpecialBetValue] = [];
                        }
                        group[item2.SpecialBetValue].push(item2);
                    });
                }
            });

            let _allDataMain = [];
            let _allData = [];
            _allDataMain = Object.keys(group).map(item => group[item]);

            _allData = _allDataMain.filter(a => {
                if (!a) return;
                return a[0].OddValue < 2.7 && a[0].OddValue >= 1.45;
            });
            // if any item not found, return first data.
            if (_allData.length === 0) {
                _allData = _allDataMain.filter(a => {
                    if (!a) return;
                    return a[0].OddValue >= 1.45;
                });
                allData = _allData.sort((a, b) => a[0].RowNumber - b[0].RowNumber);
            } else {
                _allData = _allDataMain.filter(a => {
                    if (!a) return;
                    return a[0].OddValue >= 1.45;
                });
                allData = _allData.sort((a, b) => a[0].RowNumber - b[0].RowNumber);
            }
        } else {
            // For All Odd Types
            allData = allData.sort((a, b) => a[0].RowNumber - b[0].RowNumber);
            // console.log('allData',allData,this._oddConstant.ODD_TYPE_DROPDOWN[__oddTypeItem].key);
        }

        if (this._oddConstant.ODD_TYPE_DROPDOWN[__oddTypeItem].selectLower) {
            allData = allData.sort((a, b) => b[0].RowNumber - a[0].RowNumber);

            // Tennis 5 Set special filter
            if (type === 'pre') {
                if (allData[0] && allData[0][0]) {
                    allData[0][0].SpecialBetValue = '1';
                }
            }
        }

        // Select first item of odds array. Because allData can contain many different special bet value.
        allData = allData[0];

        // For live odds need to relocation undefined or empty odds.
        if (type === 'live') {
            Object.keys(this._oddConstant.ODD_TYPE_SEQUENCE_ID[type]).forEach(sequenceID => {
                if (sequenceID == oddTypeRebuild && allData) {
                    if (true && allData.length < 3) {
                        let retData = [];
                        let _index = 0;
                        this._oddConstant.ODD_TYPE_SEQUENCE_ID[type][sequenceID].forEach(oddItem => {
                            //console.log(__data[_index], _index);
                            if (
                                _index != 2 &&
                                allData[_index] &&
                                allData[_index].ParameterOddId &&
                                allData[_index].ParameterOddId == oddItem
                            ) {
                                retData.push(allData[_index]);
                                _index++;
                            } else {
                                retData.push({
                                    OddId: -1,
                                    Visibility: 'hidden',
                                    OddValue: '0',
                                    BetStatus: 'none',
                                });
                            }
                        });
                        // console.log('data final', oddTypeRebuild, retData);
                        allData = retData;
                    }
                }
            });
        }

        return allData;
    }
}
